import Vue from 'vue'
// Notification
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

import { createModule } from 'vuexok'
import router from '@/router'
import store from '@/store'
import { ScheduledEmailsListState, IScheduledEmailsListRequest } from './types'
import { cloneEmailTemplate, deleteEmailTemplate } from '@/api/emailTemplates'
import { cancelScheduledEmail, fetchScheduledEmailsList } from '@/api/comunications'
import { DEFAULT_PER_PAGE, PER_PAGE_OPTIONS } from '@/constants/base'
import setPerPage from '@/helpers/setPerPage'

// eslint-disable-next-line import/prefer-default-export
export const appScheduledEmails = createModule(
  'appScheduledEmails',
  {
    namespaced: true,
    state: {
      tableColumns: [
        { key: 'recipients', label: 'Recipients' },
        { key: 'subject', label: 'subject', sortable: true },
        { key: 'send_at', label: 'Time Scheduled', sortable: true },
        { key: 'recurring', label: 'Recurring', sortable: false },
        { key: 'actions' },
      ],
      perPage: Number(localStorage.getItem('scheduledEmailsPerPage')) || DEFAULT_PER_PAGE,
      totalItems: 0,
      currentPage: 1,
      perPageOptions: PER_PAGE_OPTIONS,
      searchQuery: '' as string | (string | null)[],
      sortBy: 'created_at',
      isSortDirDesc: true,
      dataMeta: {
        from: 0,
        to: 0,
        of: 0,
      },
      scheduledEmail: null,
    } as ScheduledEmailsListState,
    getters: {
      getTableColumns: state => state.tableColumns,
      getPerPage: state => state.perPage,
      getTotalItems: state => state.totalItems,
      getCurrentPage: state => state.currentPage,
      getPerPageOptions: state => state.perPageOptions,
      getSearchQuery: state => state.searchQuery,
      getSortBy: state => state.sortBy,
      getIsSortDirDesc: state => state.isSortDirDesc,
      getDataMeta: state => state.dataMeta,
      getScheduledEmail: state => state.scheduledEmail,
    },
    mutations: {
      SET_PER_PAGE(state, val: number) {
        localStorage.setItem('scheduledEmailsPerPage', val.toString())
        state.perPage = val
      },
      SET_TOTAL_ITEMS(state, val: number) {
        state.totalItems = val
      },
      SET_CURRENT_PAGE(state, val: number) {
        state.currentPage = val
      },
      SET_SEARCH_QUERY(state, val: string) {
        state.searchQuery = val
      },
      SET_SORT_BY(state, val: string) {
        state.sortBy = val
      },
      SET_IS_SORT_DESC(state, val: boolean) {
        state.isSortDirDesc = val
      },
      SET_DATA_META(state, val) {
        state.dataMeta = val
      },
      SET_SCHEDULED_EMAIL(state, val) {
        state.scheduledEmail = val
      },
      SET_FILTER_PARAMS(state) {
        const query = { ...router.currentRoute.query }
        const defaultPerPage = localStorage.getItem('scheduledEmailsPerPage')
        state.currentPage = Number(query.currentPage) || 1
        state.perPage = setPerPage(query.perPage, defaultPerPage, DEFAULT_PER_PAGE)
        state.searchQuery = query.searchQuery || ''
      },
    },
    actions: {
      async fetchScheduledEmailsList({ state }) {
        try {
          const queryParams: IScheduledEmailsListRequest = {
            perPage: state.perPage,
            page: state.currentPage || 1,
            sortBy: state.sortBy,
            sortDesc: state.isSortDirDesc,
          }
          if (state.searchQuery) queryParams.subject = state.searchQuery
          const response:any = await fetchScheduledEmailsList(queryParams)

          const {
            total, from, to,
          } = response.data.meta

          const dataMeta = {
            from,
            to,
            of: total,
          }

          appScheduledEmails.mutations.SET_TOTAL_ITEMS(total)
          appScheduledEmails.mutations.SET_DATA_META(dataMeta)
          return response.data.data
        } catch (error) {
          Vue.$toast({
            component: ToastificationContent,
            props: {
              title: "Error fetching email' list",
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
          return []
        }
      },
      async cancelScheduledEmail(ctx, id) {
        try {
          await cancelScheduledEmail(id)
          Vue.$toast({
            component: ToastificationContent,
            props: {
              title: 'Success canceling scheduled email',
              icon: 'Trash2Icon',
              variant: 'info',
            },
          })
        } catch (error) {
          Vue.$toast({
            component: ToastificationContent,
            props: {
              title: 'Error canceling scheduled email',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        }
      },
    },
  },
)

appScheduledEmails.register(store)
